module.exports = __webpack_public_path__ + "src/img/play.b11c6f4c.svg";